import React, { useLayoutEffect, useRef, useState } from 'react'

interface MemberTableScrollProps {
  header: React.ReactNode
  children: React.ReactNode
}

const MemberTableScroll: React.FC<MemberTableScrollProps> = ({ header, children }) => {
  const ref = useRef<HTMLDivElement>(null)
  const innerRef = useRef<HTMLDivElement>(null)
  const [pingLeft, setPingLeft] = useState(false)

  useLayoutEffect(() => {
    const el = ref.current
    if (!el) return undefined

    const update = () => {
      const inner = innerRef.current
      const contentWidth = Math.max(
        el.clientWidth,
        inner?.scrollWidth || 0,
        inner?.querySelector<HTMLElement>('.um-refactor__table-head')?.scrollWidth || 0,
        inner?.querySelector<HTMLElement>('.um-refactor__table-body')?.scrollWidth || 0,
      )
      el.style.setProperty('--um-table-viewport', `${el.clientWidth}px`)
      el.style.setProperty('--um-table-content-width', `${contentWidth}px`)
      setPingLeft(el.scrollLeft > 0)
    }

    update()
    const observer = new ResizeObserver(update)
    observer.observe(el)
    if (innerRef.current) {
      observer.observe(innerRef.current)
    }
    el.addEventListener('scroll', update, { passive: true })
    return () => {
      observer.disconnect()
      el.removeEventListener('scroll', update)
    }
  }, [])

  return (
    <div
      ref={ref}
      className={`um-refactor__table-scroll${pingLeft ? ' um-refactor__table-scroll--ping-left' : ''}`}
    >
      <div ref={innerRef} className="um-refactor__table-inner">
        {header}
        {children}
      </div>
    </div>
  )
}

export default MemberTableScroll
